import { useApolloClient } from '@apollo/client';
import type { PortfolioReport } from '@interfaces/portfolioReport';
import { useEffect, useState } from 'react';
import { refreshPortfolioReportByIdForLookup } from '../utils/reports/resolvePortfolioReportsByIds';

export type UseRefreshedPortfolioReportOptions = {
  /** Skip refresh for completed runs so audit grids keep run-time holdings. */
  enabled?: boolean;
};

/** Refresh portfolio report when the drawer opens so holdings match the live widget. */
export const useRefreshedPortfolioReport = (
  reportId: string | undefined,
  initialReport: PortfolioReport | undefined,
  options: UseRefreshedPortfolioReportOptions = {},
): PortfolioReport | undefined => {
  const { enabled = true } = options;
  const client = useApolloClient();
  const [report, setReport] = useState(initialReport);

  useEffect(() => {
    setReport(initialReport);
  }, [initialReport, reportId]);

  useEffect(() => {
    if (!reportId || !enabled) {
      return undefined;
    }

    let cancelled = false;

    void refreshPortfolioReportByIdForLookup(client, reportId).then(
      (refreshed) => {
        if (!cancelled && refreshed) {
          setReport(refreshed);
        }
      },
    );

    return () => {
      cancelled = true;
    };
  }, [client, enabled, reportId]);

  return report;
};
